// @ts-nocheck
import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

const Layout = () => {
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <Header />

      <Box flex="1">
        <Outlet />
      </Box>

      {/* WhatsApp Floating Button */}
      {/* <MotionBox
        as="a"
        href="https://wa.me/17783172724" 
        target="_blank"
        rel="noopener noreferrer"
        position="fixed"
        bottom="20px"
        right="20px"
       bg="#25D366" 
        borderRadius="6px"
        p={3}
        boxShadow="lg"
        whileHover={{ scale: 1.3 }}
        animate={{ y: [0, -15, 0] }}
        transition={{ duration: 0.8, repeat: Infinity, ease: "easeInOut" }}
      >
       
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="white"
          viewBox="0 0 24 24"
          width="32"
          height="32"
        >
          <path d="M20.52 3.48A11.85 11.85 0 0012 0C5.37 0 0 5.37 0 12c0 2.11.55 4.16 1.61 5.96L0 24l6.24-1.63A11.94 11.94 0 0012 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.2-3.48-8.52zM12 21.82a9.77 9.77 0 01-5-1.36l-.36-.21-3.7.96.99-3.61-.23-.37A9.8 9.8 0 012.18 12C2.18 6.94 6.94 2.18 12 2.18c2.61 0 5.07 1.02 6.91 2.86A9.75 9.75 0 0121.82 12c0 5.06-4.76 9.82-9.82 9.82zm5.12-7.39c-.28-.14-1.66-.82-1.91-.91-.26-.1-.45-.14-.64.14s-.74.91-.91 1.1c-.17.18-.34.2-.62.07-.28-.14-1.18-.43-2.25-1.38-.83-.74-1.39-1.66-1.55-1.94-.16-.28-.02-.43.12-.57.12-.12.28-.34.42-.51.14-.17.18-.28.28-.47.1-.2.05-.37-.02-.51-.07-.14-.64-1.55-.88-2.13-.23-.55-.47-.48-.64-.49h-.55c-.2 0-.51.07-.78.37s-1.02 1-1.02 2.45 1.05 2.84 1.2 3.04c.14.18 2.07 3.16 5.03 4.43.7.3 1.24.48 1.66.62.7.22 1.34.19 1.85.12.56-.08 1.66-.68 1.89-1.34.23-.65.23-1.2.16-1.34-.07-.14-.25-.23-.53-.37z" />
        </svg>
      </MotionBox> */}

      {/* Call Now Floating Button */}
      {/* <MotionBox
        as="a"
        href="tel:+1 (604) 712-5656" 
        position="fixed"
        bottom="20px"
        left="20px"
       bg="#25D366" 
        borderRadius="full"
        p={3}
        boxShadow="lg"
        // whileHover={{ scale: 1.2 }}
        // animate={{ y: [0, -12, 0] }}
        // transition={{ duration: 0.8, repeat: Infinity, ease: "easeInOut" }}
      >
       
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="white"
          viewBox="0 0 24 24"
          width="32"
          height="32"
        >
          <path d="M6.62 10.79a15.53 15.53 0 006.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.56 0 1.01.45 1.01 1.01v3.5c0 .56-.45 1.01-1.01 1.01C10.61 21.03 2.97 13.39 2.97 4.01c0-.56.45-1.01 1.01-1.01h3.5c.56 0 1.01.45 1.01 1.01 0 1.24.2 2.45.57 3.57.12.35.03.74-.24 1.02l-2.2 2.2z" />
        </svg>
      </MotionBox> */}

      <Footer />
    </Box>
  );
};

export default Layout;
